import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@common-components/headers/ModalHeader';


const InformToAddIncomeSourceModal = props => {

    let {
        actions: {
            hideModal
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                data,
                index,
                callback
            }
        },
        modalHeaderProps
    } = props;

    const onCloseAction = () => {
        data
            .taxHousehold
            .householdMember[index]
            .healthCoverage
            .employerWillOfferInsuranceIndicator = false;

        data
            .taxHousehold
            .householdMember[index]
            .healthCoverage
            .offeredIchraIndicator = false;

        callback && callback(data);
    };

    const handleBtnClick = () => {
        onCloseAction();
        hideModal();
    };

    return (
        <Fragment>
            <div className = "gi-modal__header__head" >
                <ModalHeader { ...{ ...modalHeaderProps, hideModalCallback: onCloseAction } } />
            </div>
            <div className = "gi-modal__body txt-left" id = 'informToAddIncomeSourceModal' >
                <FormattedMessage
                    id = 'modals.inform_to_add_income_deduction.notice'
                    tagName = 'p'
                />
            </div>
            <div className = 'gi-modal__controls' >
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    onClick = { handleBtnClick }
                    inputRef = { boundAnchor(anchor_1) }
                >
                    <FormattedMessage id = 'button.ok' />
                </Button>
            </div>
        </Fragment>
    );
};

export default InformToAddIncomeSourceModal;
